import styled, { FlattenSimpleInterpolation } from 'styled-components';

import { Title } from '../Typography';
import theme from '../theme';

export const StyledOverAlertWrapper = styled.div`
  background-color: ${theme.white};
  padding: 0 20px;
`;

export const StyledHeaderWrapper = styled.div<{
  $elevated: boolean;
  $toursMobileView?: boolean;
}>`
  position: relative;
  ${({ $toursMobileView }) =>
    $toursMobileView &&
    `position: absolute;
    top: 28px;
    left: 0;
    right: 0;
    z-index: 200;
  `}
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    box-shadow: ${({ $elevated }) => $elevated && theme.getElevation('bottom')};
    pointer-events: none;
  }
`;

export const StyledPageHeader = styled.header<{
  $verticalAlign: string;
  $direction: string;
  $toursMobileView?: boolean;
}>`
  padding: 16px 24px;
  background: white;

  ${({ $toursMobileView }) =>
    $toursMobileView &&
    `
    padding: 8px 12px;
  `}
  display: flex;
  justify-content: space-between;
  align-items: ${({ $verticalAlign }) => $verticalAlign};
  flex-direction: ${({ $direction }) => $direction};
`;

export const StyledOverTitle = styled.div`
  grid-column-end: span 2;
  .ant-breadcrumb-link > a {
    color: ${theme.gray8};
  }
`;

export const StyledTitleWrapper = styled.div<{
  $fullTitleWidth?: boolean;
  $extraTitleMargin?: boolean;
  $toursMobileView?: boolean;
}>`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 5px;
  ${({ $fullTitleWidth }) => ($fullTitleWidth ? 'width: 100%;' : '')}
  ${({ $extraTitleMargin }) =>
    $extraTitleMargin ? 'margin-bottom: 15px;' : ''}
    ${({ $toursMobileView }) =>
    $toursMobileView &&
    `
    && {
      font-size: 16px;
    }
  `}
`;

export const StyledTitle = styled(Title)<{ $toursMobileView?: boolean }>`
  white-space: nowrap;
  margin-right: 15px;
  ${({ $toursMobileView }) =>
    $toursMobileView &&
    `
  && {
    font-size: 20px;
  }
`}
`;

export const StyledContentWrapper = styled.div<{
  $hasAside: boolean;
  $asidePlacement: 'left' | 'right';
  $asideWidth: React.ReactText;
}>`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: ${({
    $hasAside,
    $asidePlacement = 'left',
    $asideWidth = 'auto',
  }) => {
    const aside =
      typeof $asideWidth === 'number' ? `${$asideWidth}px` : $asideWidth;
    if ($hasAside) {
      if ($asidePlacement === 'right') return `auto ${aside}`;
      return `${aside} auto`;
    }
    return '1fr';
  }};
`;

export const StyledAside = styled.aside<{
  $height: string;
  $fillScreenHeight?: boolean;
  $backgroundColor: string;
  $asidePlacement: 'left' | 'right';
}>`
  ${({ $fillScreenHeight, $height }) =>
    $fillScreenHeight && `height: ${$height}`};
  ${({ $asidePlacement }) => $asidePlacement === 'right' && `grid-area: 1 / 2`};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  overflow: auto;
  padding: 25px;
`;

export const StyledBody = styled.main<{
  $height: string;
  $padding: number;
  $backgroundColor: string;
  $fillScreenHeight?: boolean;
  cssOverride?: FlattenSimpleInterpolation;
}>`
  position: relative;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  overflow: auto;
  flex-grow: 1;
  padding: ${({ $padding }) => $padding}px;

  ${({ $fillScreenHeight, $height }) =>
    $fillScreenHeight && `height: ${$height}`};

  ${({ cssOverride }) => cssOverride || ''};
`;

export const StyledPageFooter = styled.div<{ $height: number }>`
  position: fixed;
  bottom: 0;
  height: ${({ $height }) => $height}px;
  width: 100%;
`;

export const StyledPageContainer = styled.div<{
  $toursMobileView?: boolean;
}>`
  ${({ $toursMobileView }) =>
    $toursMobileView &&
    `
  flex-grow: 1;
  height: 100%;
  `}
`;
